import React from 'react';
import PropTypes from 'prop-types';
import Literal from 'components/literal';
import './styles.scss';

const ToolbarBtn = ({ icon, literal, onClick = () => null }) => (
    <div
        role="button"
        tabIndex="-1"
        className={`cfm-ic-${icon} toolbar-btn float-right`}
        onClick={onClick}
    >
        <span className="toolbar-btn-text">
            <Literal literal={literal} />
        </span>
    </div>
);

ToolbarBtn.propTypes = {
    literal: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
    onClick: PropTypes.func,
};

export default ToolbarBtn;
